export const EDEN_ENTRY_PROMPT_EVENT = "cphere:eden-entry-prompt";
export const EDEN_ENTRY_OPEN_EVENT = "cphere:eden-entry-open";
export const EDEN_ENTRY_SESSION_DISMISSED_KEY = "cphere:eden-entry-dismissed:v1";
export const EDEN_ENTRY_ATTACHMENTS_ENABLED = false;

export const EDEN_ENTRY_ATTACHMENT_POLICY = Object.freeze({
  enabled: EDEN_ENTRY_ATTACHMENTS_ENABLED,
  mode: "deferred_until_confirmed_scope",
  requiresAdvertiserScope: true,
  requiresCampaignConfirmation: true,
  reason: "Creative attachments require confirmed advertiser and campaign context before upload.",
});

const getSessionStorage = () => {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch {
    return null;
  }
};

export function hasDismissedEdenEntryThisSession(storage = getSessionStorage()) {
  try {
    return storage?.getItem(EDEN_ENTRY_SESSION_DISMISSED_KEY) === "true";
  } catch {
    return false;
  }
}

export function setEdenEntryDismissedForSession(value = true, storage = getSessionStorage()) {
  try {
    if (value) storage?.setItem(EDEN_ENTRY_SESSION_DISMISSED_KEY, "true");
    else storage?.removeItem(EDEN_ENTRY_SESSION_DISMISSED_KEY);
  } catch {}
}

export function buildEdenEntryPromptDetail(prompt) {
  const cleanPrompt = String(prompt || "").trim();
  if (!cleanPrompt) return null;
  return {
    prompt: cleanPrompt,
    source: "dashboard_eden_entry",
  };
}

export function dispatchEdenEntryPrompt(prompt, targetWindow = typeof window !== "undefined" ? window : null) {
  const detail = buildEdenEntryPromptDetail(prompt);
  if (!detail || !targetWindow?.dispatchEvent) return false;
  targetWindow.dispatchEvent(new CustomEvent(EDEN_ENTRY_PROMPT_EVENT, { detail }));
  return true;
}

export function dispatchEdenEntryOpen(targetWindow = typeof window !== "undefined" ? window : null) {
  if (!targetWindow?.dispatchEvent) return false;
  targetWindow.dispatchEvent(new CustomEvent(EDEN_ENTRY_OPEN_EVENT, {
    detail: { source: "floating_eden_button" },
  }));
  return true;
}
